import { isArrayLength } from './genericHelpers';
import moment from 'moment';

export const getUserDetails = user => {
  if (!user?.id) return null;
  const { businessName, buyerType, phoneNumber } = user?.attributes?.profile?.protectedData || {};
  const {
    location,
    hasDockingOrForklift,
    availabilityHours,
    shippingContactName,
    organizationName,
  } = user?.attributes?.profile?.publicData || {};
  return {
    businessName,
    buyerType,
    phoneNumber,
    location,
    hasDockingOrForklift,
    availabilityHours,
    shippingContactName,
    organizationName,
  };
};

export const extractFromResponse = (response, level1, level2) => {
  return response?.features?.[0]?.properties?.context?.[level1]?.[level2] || null;
};

export const getAddressObjectId = user => {
  if (!user && !user?.id) return null;

  return user?.attributes?.profile?.publicData?.addressObjectId ?? null;
};

export const getUserShippingAddress = user => {
  if (!user && !user?.id) return null;
  const { location = {} } = user?.attributes?.profile?.publicData || {};
  return location;
};

export const getUserShippingOrigin = user => {
  if (!user && !user?.id) return null;
  const { origin = {} } = user?.attributes?.profile?.publicData?.location?.selectedPlace || {};
  return origin;
};

export const getShippingDestinationAddress = (data, originType) => {
  if (!data || !data.features || data.features.length === 0) {
    return null;
  }

  const geoCodeAddress = data.features[0]?.properties?.context;

  const address = {
    locationName: originType === 'user' ? 'Destination Location' : 'Origin Location',
    address1: `${geoCodeAddress?.place?.name || ''} ${geoCodeAddress?.address?.name ||
      ''}, ${geoCodeAddress?.street?.name || ''}`,
    city: geoCodeAddress?.region?.name || '',
    stateProvinceCode: geoCodeAddress?.region?.region_code || '',
    countryCode: geoCodeAddress?.country?.country_code || '',
    postalCode: geoCodeAddress?.postcode?.name || '',
  };

  return address;
};

export const getListingOrigin = listing => {
  if (!listing) return null;
  // const { origin = {} } =
  //   listing?.attributes?.geolocation || {};
  const origin = listing?.attributes?.geolocation || {};
  return origin;
};

export const formatListingForShipping = listing => {
  if (!listing) return [];

  const { publicData, price } = listing.attributes;

  const palletWeight = getActutalWeight(listing);

  // Create the item object
  const item = {
    freightClass: 65,
    actualWeight: palletWeight?.weight || 250,
    weightUnit: 'Pounds',
    linearUnit: 'Inches',
    description: listing?.attributes?.description || 'No description',
    pallets: parseInt(publicData?.bookPallets) || 1,
    declaredValue: price?.amount || 0,
    productName: listing?.attributes.title || 'Unknown Product',
  };

  return [item];
};

export const getShopData = user => {
  const { returnPolicy, shopname } = user?.attributes?.profile?.publicData || {};
  return {
    returnPolicy,
    shopname,
  };
};

export const getPayInTotal = tx => {
  return tx?.attributes?.payinTotal?.amount ?? 0;
};

export const getDefaultDimensions = user => {
  return user?.attributes?.profile?.publicData?.packageDimensions ?? {};
};

export const createListingTitle = (values, options) => {
  if (!values) return '';

  const { pub_listing_media_types: mediaTypes, bookPallets: numberOfPallets } = values || {};
  if (!mediaTypes || !numberOfPallets) return '';

  const label =
    (isArrayLength(mediaTypes) &&
      mediaTypes.length === 1 &&
      mediaTypes[0] &&
      options.find(o => o.option === mediaTypes[0])?.label) ||
    'Mixed';

  return `${numberOfPallets} ${label} ${numberOfPallets > 1 ? 'Pallets' : 'Pallet'}`;
};

export const getListingPricingType = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.listing_pricing;
};
export const getAuctionBuyNowPrice = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.buyNowPrice || null;
};

export const getAuctionExpires = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.publicData?.auctionExpires;
};
export const getLastTransition = tx => {
  if (!tx?.id) return null;
  return tx?.attributes?.lastTransition;
};
export const getListingBids = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.metadata?.listingBids;
};

export const getPaymentShippingOriginAddress = (data, listing) => {
  if (!data || !data?.features || data?.features?.length === 0 || !listing) {
    return null;
  }
  const geoCodeAddress = data?.features[0]?.properties?.context;
  const { longitude, latitude } = data?.features[0]?.properties?.coordinates;
  const { profile } = listing?.author?.attributes;

  const origin = {
    name: 'Origin Location',
    address: {
      address1: `${geoCodeAddress?.address?.name || ''} ${geoCodeAddress?.street?.name || ''}`,
      city: geoCodeAddress?.place?.name || '',
      county: geoCodeAddress?.district?.name || '',
      lat: latitude,
      long: longitude,
      stateProvinceCode: geoCodeAddress?.region?.region_code || '',
      postalCode: geoCodeAddress?.postcode?.name || '',
      country: geoCodeAddress?.country?.country_code || '',
    },
    contactName: profile?.displayName || '',
  };

  return origin;
};

export const getPaymentShippingDestinationAddress = (data, currentUser) => {
  if (!data || !data?.features || data?.features?.length === 0 || !currentUser) {
    return null;
  }

  console.log('test1234', data)
  const geoCodeAddress = data?.features[0]?.properties?.context;
  const { longitude, latitude } = data?.features[0]?.properties?.coordinates;
  const { profile } = currentUser?.attributes;

  const destination = {
    name: 'Destination Location',
    address: {
      address1: `${geoCodeAddress?.address?.name || ''} ${geoCodeAddress?.street?.name || ''}`,
      city: geoCodeAddress?.place?.name || '',
      county: geoCodeAddress?.district?.name || '',
      lat: latitude,
      long: longitude,
      stateProvinceCode: geoCodeAddress?.region?.region_code || '',
      postalCode: geoCodeAddress?.postcode?.name || '',
      country: geoCodeAddress?.country?.country_code || '',
    },
    contactName: profile?.displayName || '',
  };

  return destination;
};


export const getShippingData = data => {
  if (!data?.attributes?.metadata?.createShippingOrderData) return null;
  return data?.attributes?.metadata?.createShippingOrderData[0];
};


export const getListingDescription = listing => {
  if (!listing?.id) return null;
  return listing?.attributes?.description;
};


export const getOrderCreatedAt = data => {
  if (!data?.attributes) return null;
  return moment(data?.attributes?.createdAt).format("Do, MMM YYYY");
}


export const getActutalWeight = listing => {
  if (!listing?.id) return null;

  const bookPallets = Number(listing?.attributes?.publicData?.bookPallets);
  const weight = bookPallets * 1100 ;

  return {weight: weight, numberOfpallets:bookPallets };
}

export const getPalletsCount = listing => {
  if (!listing?.id) return null;
  const bookPallets = Number(listing?.attributes?.publicData?.bookPallets);
  return bookPallets;
}
